import React from 'react';
import {ConfigFieldDefinitionBase} from '../../fields-definitions/config-field-definition-base';
import {OrbitConfigOverridesValueEditorComponent} from '../../../../components/value-editors/orbit-config-overrides-value-editor/orbit-config-overrides-value-editor.component';



export class OrbitConfigOverridesFieldDefinition extends ConfigFieldDefinitionBase {

    render(): React.ReactNode {
        return (<OrbitConfigOverridesValueEditorComponent/>);
    }
}